import * as R from 'ramda'
import { of } from 'rxjs'
import { filter, pairwise, switchMap } from 'rxjs/operators'
import { ofType } from 'redux-observable'
import { LOCATION_CHANGE } from 'connected-react-router'
import { ALL_FILTERS_KEYS } from 'constants/filters'
import {
  areValuesDifferent,
  getFiltersFromQuery,
  pathnameHasNotChanged
} from 'domain/filters'
import * as Actions from 'store/actions/index.ts'
import { getSelectedFilters } from 'store/selectors'

const EVENT_FILTER = 1
const EVENT_RESET = 2

const getFiltersDiff = R.pipe(
  R.map(getFiltersFromQuery),
  filters => (
    R.reduce((acc, key) => {
      if (filters[0][key] !== filters[1][key]) {
        if (filters[1][key]) {
          acc = { ...acc, [key]: { filters: filters[1][key], key, type: EVENT_FILTER } }
        } else {
          acc = { ...acc, [key]: { filters: filters[0][key], key, type: EVENT_RESET } }
        }
      }
      return acc
    }, {}, ALL_FILTERS_KEYS)
  )
)

const hasFiltersChanged = R.pipe(
  R.map(getFiltersFromQuery),
  areValuesDifferent
)

const shouldUpdateFilters = pair => R.both(
  pathnameHasNotChanged,
  hasFiltersChanged
)(pair)

const isFilterEvent = R.pipe(
  R.path(['type']),
  R.equals(EVENT_FILTER)
)

const getUpdatedFiltersList = R.ifElse(
  isFilterEvent,
  R.pipe(
    R.prop('filters'),
    R.split(',')
  ),
  R.always([])
)

const selectFiltersEpic = (
  actions$,
  state$
) => actions$.pipe(
  ofType(LOCATION_CHANGE),
  pairwise(),
  filter(shouldUpdateFilters),
  switchMap(action => of(
    Actions.filters.onSelectFilters({
      ...getSelectedFilters(state$.value),
      ...R.map(getUpdatedFiltersList, getFiltersDiff(action))
    })
  ))
)

export default selectFiltersEpic
